<div id="world-map" #worldMap></div>
<div class="chart-legend" *ngIf="showLegend">
  <div
    class="is-flex is-align-items-flex-start is-justify-content-flex-start is-flex-wrap-wrap"
  >
    <div
      *ngFor="let group of countryGroups"
      class="is-flex is-align-items-center is-justify-content-flex-start mr-4 mb-2"
    >
      <div class="group-item mr-2" [style.background-color]="group.color"></div>
      <span class="content is-small">{{ group.name }}</span>
    </div>
  </div>
</div>
